module.exports = __webpack_public_path__ + "img/dashboard_mymenus.4f454bfc.svg";